// extracted by mini-css-extract-plugin
module.exports = {"centeredContainer":"NotFound_centeredContainer__366H0","location":"NotFound_location__SHFrt","imageContainer":"NotFound_imageContainer__hS3SP","button":"NotFound_button__XIM7h"};